export default {"src":"/_next/static/media/02_LuckySpin_EN.3475f9d5.gif","height":261,"width":267};